import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { VEHICLE_WIZARD_SAMPLE } from "../consts";
import { getVehicleImage, getVehicleName } from "../helpers";
import { VehicleWizardSceneProps } from "../types";
import CheckIcon from "./CheckIcon";

/** Korak "Odabir vozila": vozilo koje se odabire i put kroz katalog (proizvođač, model, tip). */
const PickerScene: React.FC<VehicleWizardSceneProps> = ({ vehicleInfo }) => {
  const catalog = [
    { label: "Proizvođač", value: vehicleInfo.vehicleManufacturerName },
    { label: "Model", value: vehicleInfo.vehicleModelName },
    { label: "Tip", value: vehicleInfo.vehicleTypeName },
  ];

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="relative h-[12.6rem] p-[10px] rounded-t-lg bg-gradient-to-br from-amber-200 to-amber-300 overflow-hidden">
          <div className="absolute -right-6 -top-8 w-28 h-28 rounded-full bg-white/30" />
          <img
            src={getVehicleImage(vehicleInfo)}
            alt=""
            className="relative w-full h-full object-contain drop-shadow-xl"
          />
        </div>
        <div className="p-5">
          <div className="text-sm font-bold text-slate-800">{getVehicleName(vehicleInfo)}</div>
          <div className="mt-1 text-[0.7rem] text-slate-400">
            {vehicleInfo.vehicleTypeName || VEHICLE_WIZARD_SAMPLE.type}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-xs font-bold text-slate-800">Katalog vozila</div>
          <div className="mt-3 space-y-2.5">
            {catalog.map((item, index) => (
              <div key={item.label} className="flex items-center gap-2">
                {item.value ? (
                  <CheckIcon />
                ) : (
                  <span className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-50 text-[0.6rem] font-bold text-blue-600 flex-shrink-0">
                    {index + 1}
                  </span>
                )}
                <div className="min-w-0">
                  <div className="text-[0.6rem] text-slate-400">{item.label}</div>
                  <div className="text-[0.7rem] font-semibold text-slate-700 truncate">
                    {item.value || "Odaberite"}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Tehnički podaci su spremni"
          subtitle="Snaga, gorivo i mjenjač"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(PickerScene);
